// extracted by mini-css-extract-plugin
module.exports = {"snippetOptions":"snippet-question_snippetOptions__1HQDr","returnButtons":"snippet-question_returnButtons__uO7ln","fade-in":"snippet-question_fade-in__3Ztve"};